/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Calendar } from "react-multi-date-picker";
import { Button, Input } from "../../components";
import { GetSlotsOfCourt } from "../../utilities/api/courts";
import { format } from "date-fns";
import { useAppSelector } from "../../redux/Hooks/Hook";

const CalendarModal = (props: any) => {
  const {
    show,
    handleClose,
    setSelectedSlots,
    selectedSlots,
    courtId,
    slotDate,
    reschedule,
    rescheduleSlot,
    setRescheduleSlot,
    forBooking,
    maxPreBookingDay,
  } = props;
  const [slots, setSlots] = useState(
    forBooking === "Add_Booking" ? selectedSlots.selectedSlots : selectedSlots
  ) as any[];
  const [date, setDate] = useState(format(new Date(), "dd-MM-yyyy"));
  const [availableSlot, setAvailableSlot] = useState([]) as any;
  const { UserRole } = useAppSelector((state) => state.verifiedUser);

  const handleDateChange = (e: any) => {
    setDate(e.format("DD-MM-YYYY"));
  };

  useEffect(() => {
    setDate(slotDate);
  }, [slotDate]);
  const handleChecked = (checked: boolean, data: any) => {
    data.bookingDate = date.split("-").reverse().join("-");
    let RP = data.ratePerSlot;
    delete data.courtId;
    delete data.courtName;
    delete data.ratePerSlot;
    let temp = slots.length
      ? slots.map((elem: any) => elem.fromTime + elem.bookingDate)
      : [];
    let addOrNot = temp.includes(data.fromTime + data.bookingDate);

    if (reschedule) {

      data.id =
        slots.length === 1
          ? forBooking === "Add_Booking"
            ? selectedSlots.selectedSlots[0]?.id
              ? selectedSlots.selectedSlots[0].id
              : ""
            : selectedSlots[0]?.id
              ? selectedSlots[0].id
              : ""
          : "";
      checked
        ? addOrNot
          ? setSlots([...slots])
          : setSlots([...slots, data])
        :
        setSlots(
          slots.filter(
            (elem: any) =>
              elem.fromTime + elem.bookingDate !==
              data.fromTime + data.bookingDate
          )
        );

    } else {
      checked
        ? addOrNot
          ? setSlots([...slots])
          : setSlots([...slots, data])
        :
        setSlots(
          slots.filter(
            (elem: any) =>
              elem.fromTime + elem.bookingDate !==
              data.fromTime + data.bookingDate
          )
        );
    }
    data.ratePerSlot = RP;
  };

  useEffect(() => {
    setSlots(
      forBooking === "Add_Booking" ? selectedSlots.selectedSlots : selectedSlots
    );
  }, [selectedSlots?.selectedSlots, selectedSlots]);

  const handleAdd = () => {

    setSelectedSlots(
      forBooking === "Add_Booking"
        ? { ...selectedSlots, selectedSlots: [...slots] }
        : slots
    );
    if (reschedule) {
      if (slots.length > 1) {
        let indexToRemove = slots?.findIndex(
          (obj: any, index: number, array: any) => {
            return (
              array.findIndex((innerObj: any) =>
                innerObj.id !== "" ? innerObj.id : null === obj?.id
              ) === index
            );
          }
        );

        if (indexToRemove > -1) {
          slots.splice(indexToRemove, 1);
        }

        const mergedArray = rescheduleSlot.map((obj1: any) => {
          const matchingObjIndex = slots.findIndex(
            (obj2: any) =>
              obj2.fromTime === obj1.fromTime &&
              obj2.bookingDate === obj1.bookingDate
          );
          if (matchingObjIndex !== -1) {
            slots.splice(matchingObjIndex, 1);
          }
          return obj1;
        });
        setRescheduleSlot([...mergedArray, ...slots]);
      } else {
        const mergedArray = rescheduleSlot.map((obj1: any) => {
          const matchingObjIndex = slots.findIndex(
            (obj2: any) =>
              obj2.fromTime === obj1.fromTime &&
              obj2.bookingDate === obj1.bookingDate
          );
          if (matchingObjIndex !== -1) {
            slots.splice(matchingObjIndex, 1);
          }
          return obj1;
        });
        setRescheduleSlot([...mergedArray, ...slots]);
      }
    }
    handleClose();
  };

  const GetSlot = async () => {
    setAvailableSlot([]);
    if (courtId) {
      const result = await GetSlotsOfCourt(
        courtId,
        date.split("-").reverse().join("-")
      );
      if (result?.statusCode == "200") {
        setAvailableSlot(result.data.timeSlots);
      }
    }
  };
  useEffect(() => {
    GetSlot();
  }, [date, show]);

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Calendar</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="slot-selection">
          <Row className="g-0">
            <Col lg={4}>
              <div className="text-start mb-3">
                <label htmlFor="" className="form-label">
                  Select Date
                </label>
                <Calendar
                  format="dd-MM-yyyy"
                  value={new Date(date.split("-").reverse().join("-"))}
                  onChange={(e: any) => handleDateChange(e)}
                  minDate={new Date()}
                  maxDate={
                    UserRole.role.name !== "SUPER_ADMIN"
                      ? new Date().setDate(
                        new Date().getDate() + maxPreBookingDay - 1
                      )
                      : ""
                  }
                />
              </div>
            </Col>
            <Col lg={8} className="gx-4">
              <label htmlFor="" className="form-label">
                Available Slots
              </label>
              <div className="available-slot d-flex flex-wrap gap-2">
                {availableSlot.length ? (
                  availableSlot.map((item: any, index: number) => {
                    return (
                      <span key={"check" + index} style={{ width: "110px" }}>
                        <Input
                          onChange={(e: any) =>
                            handleChecked(e.target.checked, item)
                          }
                          checked={
                            slots?.find(
                              (elem: any) =>
                                elem.fromTime === item.fromTime &&
                                elem.bookingDate === item.bookingDate
                            )
                              ? true
                              : false
                          }
                          id={"slot" + index}
                          type="checkbox"
                          name={"slot" + index}
                          className="btn-check"
                        />
                        <label
                          htmlFor={"slot" + index}
                          className="bg-light bg-opacity-50 border border-2 btn btn-sm p-1 w-100"
                        >
                          <div className="slot-box text-start">
                            <span className="d-block">
                              {item.fromTime} to {item.toTime}
                            </span>
                            <span className="text-primary">
                              <span className="rupees-symbol">&#8377;</span>{" "}
                              {item.ratePerSlot.toFixed(2)}
                            </span>{" "}
                            {item.discountPercent && (
                              <>
                                <del>
                                  <span>
                                    <span className="rupees-symbol">
                                      &#8377;
                                    </span>{" "}
                                    {item.actualRatePerSlot.toFixed(2)}
                                  </span>
                                </del>

                              </>
                            )}
                          </div>
                        </label>
                      </span>
                    );
                  })
                ) : (
                  <span className="alert alert-danger text-center w-100">
                    No Slots Available
                  </span>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleAdd}
          type="button"
          bname="Add"
          name="addslot"
          id="addslot"
          className="btn btn-primary rounded-1"
        ></Button>
      </Modal.Footer>
    </Modal>
  );
};

export { CalendarModal };
